import { render, staticRenderFns } from "./ChatThreads.vue?vue&type=template&id=463084f6&scoped=true&lang=pug"
import script from "./ChatThreads.vue?vue&type=script&lang=js"
export * from "./ChatThreads.vue?vue&type=script&lang=js"
import style0 from "./ChatThreads.vue?vue&type=style&index=0&id=463084f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463084f6",
  null
  
)

export default component.exports